import { render, staticRenderFns } from "./selectVote.vue?vue&type=template&id=630e5732&scoped=true"
import script from "./selectVote.vue?vue&type=script&lang=js"
export * from "./selectVote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e5732",
  null
  
)

export default component.exports